export default __webpack_public_path__ + "static/mainvisual-7e2450a053e183fa44a9f4ef2cc816a6.png";